import { customAlphabet } from 'nanoid';
import Session from './Session';

const sshGenerator = (nanoIdLength = 12) =>
  customAlphabet('1234567890aAbBCcdDeEfFgGhHjJkKmMnNpPqQrRsSuUwWxXyYzZ', nanoIdLength)();

let Helpers = {
  setTpHeaders: (headers = {}) => {
    headers['X-Requested-With'] = 'XMLHttpRequest';
    headers['X-HPTM-Transaction-ID'] = 'DUI_' + sshGenerator();
    if (localStorage.getItem('daas_session_id')) {
      headers['X-HPTM-Session-ID'] = 'DUI_' + localStorage.getItem('daas_session_id');
    }
    return headers;
  },
};

export function getTpAuthorization(toggle = false) {
  let headers = {};
  if (Session.getToken()) {
    headers['Authorization'] = `Bearer ${Session.getToken()}`;
  }
  if (toggle) {
    headers['idp_token'] = localStorage.getItem('idp_token');
  }
  return Helpers.setTpHeaders(headers);
}
export function setTpHeaders(headers = {}, toggle = false) {
  if (toggle) {
    headers.idp_token = localStorage.getItem('idp_token');
    return Helpers.setTpHeaders(headers);
  }
  return Helpers.setTpHeaders(headers);
}
